import { render, staticRenderFns } from "./FifteenDaysBibaran.vue?vue&type=template&id=b1bc6978&scoped=true&"
import script from "./FifteenDaysBibaran.vue?vue&type=script&lang=js&"
export * from "./FifteenDaysBibaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bc6978",
  null
  
)

export default component.exports